export const initialState = {
  base: {
    allIDs: [],
    byId: {},
  },
  byOrganization: {
    // :organizationId
  },
  ui: {
    isCreatingBoard: false,
    isDeactivatingBoard: false,
    isFetchingBoard: false,
    isFetchingBoards: false,
    isUpdatingBoard: false,
  },
};

export const boardPartialSchema = {
  additionalProperties: true,
  properties: {
    afterHours: { type: 'object' },
    archived: { default: false, type: 'boolean' },
    businessHours: { type: 'object' },
    createdAt: { type: 'number' },
    departmentIDs: { type: ['array', 'null'] },
    id: { type: 'string' },
    name: { type: 'string' },
    nickname: { type: 'string' },
    organizationId: { type: 'string' },
    teamMembers: { type: ['array', 'null'] },
  },
  type: ['object', 'null'],
};

export const boardSchema = {
  additionalProperties: true,
  properties: {
    active: { default: false, type: 'boolean' },
    afterHours: { type: 'object' },
    businessHours: { type: 'object' },
    createdAt: { type: 'number' },
    departmentIDs: { type: ['array', 'null'] },
    email: { type: 'string' },
    forwardName: { type: 'string' },
    forwardTo: { type: 'string' },
    id: { type: 'string' },
    name: { type: 'string' },
    nickname: { type: 'string' },
    organizationId: { type: 'string' },
    phoneNumber: { type: 'string' },
    recipients: { type: ['array', 'null'] },
    team: { type: 'object' },
    timezone: { type: 'object' },
    voicemailUrl: { type: 'string' },
  },
  type: ['object', 'null'],
};
